<template>
	<div class="page-not-found">
		<img src="@/assets/img/alert.png">

		<h1>
			Page not found
		</h1>

		<button
			class="_primary"
			@click="$router.push('/')"
		>
			Go Back
		</button>
	</div>
</template>
<script>
export default {
	name: 'PageNotFound'
}
</script>

<style lang="scss" scoped>
	.page-not-found {
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #ffffff;
		height: 100%;
		width: 100%;
		padding: 150px 0 50px 0;

		h1 {
			font-size: 40px;
			color: #777;
			margin: 30px 0;
		}

	}
</style>
